import { useState } from "react";
import { Copy, Check } from "lucide-react";

interface CodeBlockProps {
  code: string;
  language?: string;
}

export function CodeBlock({ code, language }: CodeBlockProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="relative group">
      {language && (
        <span className="absolute top-2 left-3 text-[10px] uppercase tracking-wider text-base-content/40 font-semibold select-none">
          {language}
        </span>
      )}
      <button
        onClick={handleCopy}
        className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity btn btn-ghost btn-xs btn-square"
        aria-label="Copy code"
      >
        {copied ? (
          <Check className="w-3.5 h-3.5 text-success" />
        ) : (
          <Copy className="w-3.5 h-3.5 text-base-content/60" />
        )}
      </button>
      <pre className="bg-base-200 rounded-lg p-4 text-xs font-mono overflow-x-auto">
        {language && <span className="block h-4" />}
        <code>{code}</code>
      </pre>
    </div>
  );
}
